'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var dataHelper = require('../../helper/dataHelper');
var ColorImage = require('../common/ColorImage');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');

/**
 * 安卓状态栏
 */
var AndroidStatusBar = React.createClass({
  render: function () {
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var isLightColor = dataHelper.isLightColor(bgColor);
    var color = styleHelper.getPropertyValue(this.props,'ForegroundColor');   // this.props.ForegroundColor;
    if (this.props.IsAutoTextColor) {
      if (isLightColor) {
        color = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
      } else {
        color = GlobalConst.GLOBAL_COLOR.SYSTEM_WHITE;
      }
    }
    return (
      <div className="android-status-bar-content" key={this.props.controlID} style={{
        backgroundColor: bgColor,
        width: '100%',
        height: '100%'
      }}>
        <ColorImage {...{
            src: assetsHelper.getComponentAsset('StatusBar(Android)'),
            height: 20,
            width: '100%',
            color: color,
            gridRect: {
              left: 1,
              right: 220
            }
          }}
          style={{
            width: '100%',
            height: 20,
            position: 'absolute',
            top: (styleHelper.getHeight(this.props) - 20) / 2
        }}/>
      </div>
    );
  }
});

module.exports = AndroidStatusBar;


// WEBPACK FOOTER //
// ./src/views/Components/AndroidStatusBar.jsx